export var EGenericButtonType;
(function (EGenericButtonType) {
    EGenericButtonType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
    EGenericButtonType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
})(EGenericButtonType || (EGenericButtonType = {}));
export var EGenericButtonThemes;
(function (EGenericButtonThemes) {
    EGenericButtonThemes["PRIMARY"] = "PRIMARY";
    EGenericButtonThemes["TERTIARY"] = "TERTIARY";
    EGenericButtonThemes["DANGER"] = "DANGER";
})(EGenericButtonThemes || (EGenericButtonThemes = {}));
